// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"4e68bc26","135":"8a7f483d","280":"8a7f483d","340":"8a7f483d","396":"4e68bc26","408":"8a7f483d","576":"8a7f483d","585":"b8ef4379","964":"4e68bc26"}[chunkId] + ".chunk.css";
};